import React, { useEffect } from 'react';

// bottom sheet that holds the search filters on phones
export const FilterSheet = ({ title, closeLabel, onClose, footer, children }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        // the page behind the sheet should not scroll
        const overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = overflow;
        };
    }, [onClose]);

    return (
        <div className='hs-sheet-overlay' onClick={onClose}>
            <div className='hs-sheet' role='dialog' aria-label={title} onClick={(e) => e.stopPropagation()}>
                <div className='hs-sheet-head'>
                    <h2>{title}</h2>
                    <button className='hs-msg-x' onClick={onClose} aria-label={closeLabel}>×</button>
                </div>
                <div className='hs-sheet-body'>{children}</div>
                <div className='hs-sheet-foot'>{footer}</div>
            </div>
        </div>
    );
};

export const SheetSection = ({ label, children }) => (
    <section className='hs-sheet-section'>
        <p className='hs-sheet-label'>{label}</p>
        {children}
    </section>
);
